import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const YEARS = Array.from({ length: 101 }, (_, index) => String(2000 + index));

export const GiveawayMonthPicker = ({ value, onChange }) => {
  const [year, month] = value.split('-');
  return <div className="min-w-0 max-w-full">
    <p className="text-xs font-semibold mb-1" id="giveaway-month-label">Campaign month · Eastern Time</p>
    <div className="flex gap-2 max-w-full" aria-labelledby="giveaway-month-label">
      <Select value={month} onValueChange={next => onChange(`${year}-${next}`)}>
        <SelectTrigger className="w-36 max-w-full bg-white border-navy/20 h-[38px]" aria-label="Campaign month" data-testid="giveaway-month-select"><SelectValue placeholder="Month" /></SelectTrigger>
        <SelectContent className="max-h-64" data-testid="giveaway-month-menu">{MONTHS.map((label, index) => {
          const id = String(index + 1).padStart(2, '0');
          return <SelectItem key={id} value={id} data-testid={`giveaway-month-option-${id}`}>{label}</SelectItem>;
        })}</SelectContent>
      </Select>
      <Select value={year} onValueChange={next => onChange(`${next}-${month}`)}>
        <SelectTrigger className="w-24 bg-white border-navy/20 h-[38px]" aria-label="Campaign year" data-testid="giveaway-year-select"><SelectValue placeholder="Year" /></SelectTrigger>
        <SelectContent className="max-h-64" data-testid="giveaway-year-menu">{YEARS.map(item => <SelectItem key={item} value={item} data-testid={`giveaway-year-option-${item}`}>{item}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  </div>;
};